import React from 'react'
import classnames from 'classnames'

const InputErrorMessage = ({ className, ...rest }) => (
  <span
    className={classnames('font-semibold text-frolyPink text-xs', className)}
    aria-live="polite"
    {...rest}
  />
)

export default InputErrorMessage
